import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription } from 'rxjs';
import { PermissionHelper } from 'app/core/utils/permission.helper';

@Directive({
  selector: '[appNotHasRight]',
})
export class NotHasRightDirective implements OnInit, OnDestroy {
  private currentUser;
  private rights: number[];
  private getUserDataSubscription: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private oidcSecurityService: OidcSecurityService,
  ) {}

  ngOnInit() {
    this.getUserDataSubscription = this.oidcSecurityService.userData$.subscribe((userData: any) => {
      // Handle the nested structure - actual user data is in userData.userData
      this.currentUser = userData?.userData;
      this.updateView();
    });
  }

  ngOnDestroy() {
    if (this.getUserDataSubscription) {
      this.getUserDataSubscription.unsubscribe();
    }
  }

  @Input()
  set appNotHasRight(val) {
    this.rights = val;
    this.updateView();
  }

  private updateView() {
    if (!this.checkPermission()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  private checkPermission() {
    return PermissionHelper.hasAnyRight(this.currentUser, this.rights);
  }
}
